import React from 'react';

import DeclensionUtils from 'application/utils/DeclensionUtils';

import { StreamType } from '@entities/stream';
import styles from './index.module.scss';
import StreamPreviewCard from '../StreamPreviewCard';
import { POINTS_TYPES_ENUM } from '../StreamPreviewCardRenderer';

interface Props {
  text: string;
  pointData: StreamType[];
  streamIds: Map<string, boolean>;
  type: POINTS_TYPES_ENUM;
  setStreamIds: React.Dispatch<React.SetStateAction<Map<string, boolean>>>;
  setIsAllSelected: React.Dispatch<React.SetStateAction<boolean>>;
}

const StreamPreviewSection = (props: Props) => {
  const { text, pointData, streamIds, type, setStreamIds, setIsAllSelected } = props;

  return (
    <div className={styles.StreamPreviewSection}>
      <span className={styles.StreamPreviewSectionTitle}>{text}</span>
      {pointData?.map((stream) => {
        const description = `${stream.pointsNum} ${DeclensionUtils.pluralPointsEnding(stream.pointsNum)}`;
        const title = stream.title;

        return (
          <StreamPreviewCard
            key={stream.id}
            id={stream.id}
            title={title}
            description={description}
            imgLink={stream.cover?.miniatureUri ?? ''}
            streamIds={streamIds}
            type={type}
            setStreamIds={setStreamIds}
            setIsAllSelected={setIsAllSelected}
          />
        );
      })}
    </div>
  );
};

export default StreamPreviewSection;
